import { ImageBox } from '../ImageBox';

export const ImageGrid = ({ hidden, images, onEdit, onRemove }) => {
  return (
    <div className={hidden ? 'row justify-content-center align-content-center m-0 hidden' : 'row justify-content-center align-content-center m-0 g-2'} id="image-container">
      {images.length === 0 ? (
        <h1 className="text-center mt-3">Upload an image to get started.</h1>
      ) : (
        images.map((image) => (
          <ImageBox key={image.id} image={image} onEdit={onEdit} onRemove={onRemove} />
        ))
      )}
    </div>
  );
}

